var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rating
    ? _c("div", { staticClass: "requirement-rating" }, [
        _vm.title
          ? _c("p", [_c("strong", [_vm._v(_vm._s(_vm.title) + ":")])])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "requirement-rating-icons" },
          _vm._l(5, function (index) {
            return _c("i", {
              key: index,
              staticClass: "icon icon-wanderer-large",
            })
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "requirement-rating-icons-overlay" },
          [
            _vm._l(parseInt(_vm.rating), function (index) {
              return _c("i", {
                key: index,
                staticClass: "icon icon-wanderer-large",
              })
            }),
            _vm._v(" "),
            _vm.hasHalfRating
              ? _c("i", { staticClass: "icon icon-wanderer-large-half" })
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }